exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-emotion {\n  display: inline-block;\n}\n.vux-static-emotion {\n  width: 0.75rem;\n  height: 0.75rem;\n  display: inline-block;\n}\n", ""]);

// exports
